var _defs, _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsertImportFilesSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}.cls-2{fill:#009ad9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "InsertImportFiles_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16 21.83 16 26 13 26 10.67 26 10 26 6 26 2 26 2 13 8 13 8 6 16 6 16 10.17 18 8.17 18 4 7.04 4 0 10.75 0 28 6 28 10 28 11.26 28 11.67 28 13 28 16 28 18 28 18 26 18 23.83 16 21.83"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13 16 21 24 21 19 30 19 30 13 21 13 21 8 13 16"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertImportFilesSvg);
export default __webpack_public_path__ + "static/media/InsertImportFiles_svg.0dbef1c325dedae0b2fde878a614512c.svg";
export { ForwardRef as ReactComponent };